/** @format */

import React, { useState } from 'react'
import Modal from 'react-modal'
import TnCs from '../TnCs'
import PrivacyPolicy from '../PrivacyPolicy'
import { useGA4React } from 'ga-4-react'

import './style.css'

export function GameOver(props) {
  const [email, setEmail] = useState('')
  const [newsletter, setNewsletter] = useState(false)
  const [emailIsValid, setEmailIsValid] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [tncsView, setTncsView] = useState(false)
  const [privacyPolicyView, setPrivacyPolicyView] = useState(false)

  const ga = useGA4React()

  const openTncs = () => {
    // setTncsView(!tncsView)
    ga.event('terms_&_conditions_click', 'Flavour Drop')
  }

  const openPrivacyPolicy = () => {
    // setPrivacyPolicyView(!privacyPolicyView)
    ga.event('privacy_policy_click', 'Flavour Drop')
  }

  const infoModalClasses = {
    base: 'info-modal',
    afterOpen: 'info-modal--after-open',
    beforeClose: 'info-modal--before-close',
  }
  const infoModalOverlayClasses = {
    base: 'info-modal-overlay',
    afterOpen: 'info-modal-overlay--after-open',
    beforeClose: 'info-modal-overlay--before-close',
  }

  const validateEmail = () => {
    if (email !== '') {
      const validEmailRegex = RegExp(
        // eslint-disable-next-line
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
      )
      const result = validEmailRegex.test(email)
      setEmailIsValid(result)
      return result
    } else {
      setEmailIsValid(false)
      return false
    }
  }

  const submitEntry = event => {
    event.preventDefault()
    if (validateEmail() === true) {
      setIsSubmitting(true)

      var formdata = new FormData()
      // formdata.append('fruit', '')
      formdata.append('email', email)
      formdata.append(
        'discountType',
        props.score >= props.maxGoalCount ? 'Free Pack' : 'Free Shipping',
      )
      formdata.append('newsletter', newsletter)
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
      }
      fetch(process.env.REACT_APP_PROMO_API, requestOptions)
        .then(response => {
          setIsSubmitting(false)
          if (response.status === 200) {
            props.collectEmailRef(email)
            afterSubmit()
          } else {
            setIsSubmitting(false)
            response.text().then(text => alert(text))
          }
        })
        .catch(error => {
          setIsSubmitting(false)
          alert(error)
        })
    }
  }

  function afterSubmit() {
    props.onSubmission()
    ga.event('form_submitted', 'Flavour Drop')
  }

  return (
    <div className="game-ended">
      <div className="content">
        <div className="title">{props.title}</div>
        <div className="text">{props.message}</div>
        <form onSubmit={submitEntry} className="form" autoComplete="off">
          <input
            className={`email-input ${!emailIsValid ? 'error' : ''}`}
            type="email"
            name="email"
            placeholder="Please enter your email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoComplete="off"
            // required
          />
          <div className="checkbox">
            <input
              id="newsletter"
              type="checkbox"
              className={`form-check-input`}
              defaultChecked={newsletter}
              onChange={event => setNewsletter(event.currentTarget.checked)}
            />
            <label htmlFor="newsletter" className="">
              {' '}
              I am happy to hear from Vuse&nbsp;
            </label>
          </div>
          <button
            type="submit"
            // onClick={submitEntry}
            alt="Submit Your Email"
            // width="291"
            // height="53"
            className="btn btn-primary"
            disabled={isSubmitting}
          >
            <span className={`btn-label ${isSubmitting ? 'btn-loading' : ''}`}>
              SUBMIT YOUR EMAIL
            </span>
          </button>
        </form>
        {/* <button className="btn" onClick={props.onPress}> */}
        {/*   {props.button} */}
        {/* </button> */}
        <p className="text-small">*Limit of one code per user.</p>
        <p className="text-small">
          Your details will be collected in accordance with{' '}
          <br className="mobile-only" />
          our{' '}
          <a
            href="https://vuse.co.nz/pages/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white', textDecoration: 'none' }}
            onClick={() => openPrivacyPolicy()}
          >
            <span
              className="bold"
              // onClick={() => openPrivacyPolicy()}
              style={{ cursor: 'pointer' }}
            >
              Privacy Policy
            </span>
          </a>
          <br className="desktop-only" /> and you can opt out of the{' '}
          <br className="mobile-only" />
          vaping newsletters at any time. <br />
          <a
            href="https://vuse.co.nz/pages/flavour-drop"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white', textDecoration: 'none' }}
            onClick={() => openTncs()}
          >
            <span
              className="bold"
              style={{ cursor: 'pointer' }}
              // onClick={() => openTncs()}
            >
              Promotional T&C's
            </span>{' '}
            apply.
          </a>
        </p>
      </div>

      {/* Terms & Conditions modal */}
      <Modal
        className={infoModalClasses}
        overlayClassName={infoModalOverlayClasses}
        isOpen={tncsView}
        onRequestClose={() => setTncsView(!tncsView)}
        closeTimeoutMS={500}
      >
        <button className="btn-close" onClick={() => setTncsView(!tncsView)}>
          &times;
        </button>
        <div className="modal-content">
          <TnCs />
        </div>
      </Modal>

      {/* Privacy Policy modal */}
      <Modal
        className={infoModalClasses}
        overlayClassName={infoModalOverlayClasses}
        isOpen={privacyPolicyView}
        onRequestClose={() => setPrivacyPolicyView(!privacyPolicyView)}
        closeTimeoutMS={500}
      >
        <button
          className="btn-close"
          onClick={() => setPrivacyPolicyView(!privacyPolicyView)}
        >
          &times;
        </button>
        <div className="modal-content">
          <PrivacyPolicy />
        </div>
      </Modal>
    </div>
  )
}

export default GameOver
